import React from 'react'

import SignIn from './SignIn';
import SignUp from './SignUp';

const SignInAndSignUp = () => (
  <div>
    <SignIn />
    <SignUp />
  </div>
);

export default SignInAndSignUp;
